// Dutch language settings for the defailt frontend.
export const isMultilingual = false;
export const supportedLanguages = ['nl'];
export const defaultLanguage = 'nl';
